import React from "react";
import { MultiSelect } from "react-multi-select-component";

const OutlookInbox = ({ mailboxes = [], selectedMailboxIds = [], onChange, loading }) => {
    const options = mailboxes.map((mailbox) => ({
        label: mailbox.name || mailbox.email,
        value: mailbox.id || mailbox._id,
    }));

    return (
        <div className="drop-header">
            <MultiSelect
                className="gmail-scroll"
                options={options}
                value={selectedMailboxIds}
                onChange={onChange}
                labelledBy="Select Outlook Accounts"
                disabled={loading || options.length === 0}
            />
        </div>
    );
};

export default OutlookInbox;
